import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { WebsocketService } from './websocket.service';

@Component({
    // tslint:disable-next-line
    selector: 'body',
    template: `
    <ngx-loading-bar [includeSpinner]="false" height="2px" ref="http" color="#dc3545"></ngx-loading-bar>
    <router-outlet></router-outlet>
    `
})
export class AppComponent implements OnInit {
    constructor(private router: Router, private ws: WebsocketService) { }

    ngOnInit() {
        this.router.events.subscribe((evt) => {
            if (!(evt instanceof NavigationEnd)) {
                return;
            }
            window.scrollTo(0, 0);
        });
    }

    ngOnDestroy(): void {
        // en apps SPA casi nunca se llama,
        // pero si tu app se llega a desmontar (por ejemplo en tests)
        this.ws.disconnect();
    }
}
